<template>
    <div id="extra-documents">
        <div class="vx-row px-2 py-8">
            <div class="vx-col w-full">
                <h3>Documentos adicionales</h3>
                <p>
                    Sí necesitas algún documento no contemplado dentro de la solicitud, puedes subirlo aquí.
                </p>
                <vs-divider></vs-divider>
                <UserDocumentControl
                    :userId="userId" />
            </div>
        </div>
    </div>
</template>
<script>
import UserDocumentControl from "@components/projectsv3/components/UserDocumentControl.vue";

export default {
    data: () => ({

    }),
    props: {
        source: Object
    },
    components: {
        UserDocumentControl,
    },
    computed: {
        userId() {
            return this.source.client.user_id;
        }
    }
}
</script>